import { api } from "@/lib/api";

export const draftToken = () => sessionStorage.getItem("nxt_assessment_token");
export const draftConfig = () => ({ headers: { "X-Assessment-Draft": draftToken() } });
export const hasReveal = () => Boolean(draftToken() && sessionStorage.getItem("nxt_assessment_revealed"));
export const readDraft = () => api.get("/assessment/draft", draftConfig());
export const clearDraft = () => {
  sessionStorage.removeItem("nxt_assessment_token");
  sessionStorage.removeItem("nxt_assessment_revealed");
};
export const saveDraft = async () => {
  if (!hasReveal()) return;
  await api.post("/assessment/draft/claim", {}, draftConfig());
  clearDraft();
};
